import { numberToString, toSuper } from "../../util/string-util.js";
/**
 * A independent has the form multiplier * name^power. e.g. 3x^4. Independents
 * appear in Terms, which is a list of independents that are all multiplied
 * with each other.
 */
export class Independent {
    static CONSTANT = "_";
    static g(mult, name, pow) {
        const mType = typeof mult;
        const nType = typeof name;
        const pType = typeof pow;
        if (pType !== "undefined") {
            return new Independent(mult, name, pow); //Independent.g(mult: number, name: string, pow: number): Independent
        }
        else if (nType !== "undefined") {
            return mType === "number"
                ? new Independent(mult, name, 1) //Independent.g(mult: number, name: string): Independent
                : new Independent(1, mult, name); //Independent,g(name: string, pow:number): Independent
        }
        else {
            return mType === "number"
                ? new Independent(mult, Independent.CONSTANT, 1) //Independent.g(mult: number): Independent
                : new Independent(1, mult, 1); //Independent.g(name: string ): Independent
        }
    }
    mult;
    name;
    pow;
    constructor(mult, name, pow) {
        if (typeof mult === "number") {
            this.mult = mult;
            this.name = name;
            this.pow = pow;
        }
        else {
            this.mult = mult.mult;
            this.name = mult.name;
            this.pow = mult.pow;
        }
    }
    /**
     * Clone this independent
     * @returns the cloned independent
     */
    clone() {
        return new Independent(this);
    }
    /**
     * Normalizes this independent (when it is not a constant) by setting it's multiplier to 1.
     * The old multiplier gets returned
     * @returns A 1 gets returned when this independent is a constant, other wise the old multiplier.
     */
    normalize() {
        let _mult = 1;
        if (!this.isConstant()) {
            _mult = this.mult;
            this.mult = 1;
        }
        return _mult;
    }
    /**
     * Checks whether this independent represents a constant.
     * @returns true when this independent represents a constant
     */
    isConstant() {
        return this.name === Independent.CONSTANT;
    }
    /**
     * Checks whether this independent represents a zero.
     * @returns true when independent represents a 0
     */
    isZero() {
        return this.mult === 0;
    }
    /**
     * Check whether this independent represents a one.
     * @returns true when independent represents a 1
     */
    isOne() {
        return this.isConstant()
            ? Math.abs(this.mult) == 1
            : !this.isZero() && this.pow == 0;
    }
    /**
     * Checks whether this independent represents a negative constant or has a negative multiplier.
     * @returns true when independent represents a negative constant or has a negative multiplier
     */
    isNegative() {
        return (this.isConstant() ? Math.pow(this.mult, this.pow) : this.mult) < 0;
    }
    /**
     * Inverts the sign of this independent when not zero.
     * @returns the now inverted independent itself
     */
    invert() {
        if (!this.isZero()) {
            this.mult *= -1;
        }
        return this;
    }
    toSourceCode(forceSign = false, emptyOnOne = true) {
        return this.toText(forceSign, emptyOnOne, true, (pow) => `_p${pow}`);
    }
    toString(forceSign = false, emptyOnOne = true) {
        return this.toText(forceSign, emptyOnOne, false, toSuper);
    }
    toText(forceSign, emptyOnOne, forceNoneInteger, toPower) {
        let sb = "";
        if (this.isNegative()) {
            sb += "-";
        }
        else if (forceSign) {
            sb += "+";
        }
        if (this.isOne() && emptyOnOne) {
        }
        else {
            if (this.isZero()) {
                sb += numberToString(0, forceNoneInteger);
            }
            else if (this.isOne()) {
                sb += numberToString(1, forceNoneInteger);
            }
            else if (this.isConstant()) {
                sb += numberToString(Math.abs(Math.pow(this.mult, this.pow)), forceNoneInteger);
            }
            else {
                if (Math.abs(this.mult) != 1) {
                    sb += numberToString(Math.abs(this.mult), forceNoneInteger);
                }
                sb += this.name;
                if (this.pow != 1) {
                    sb += toPower(this.pow);
                }
            }
        }
        return sb;
    }
    getOperationsHistogram() {
        const histogram = {};
        if (this.pow != 1)
            histogram[`^${this.pow}`] = 1;
        if (this.mult != 1)
            histogram[`*`] = 1;
        return histogram;
    }
}
